export const CHROME_EXTENSION_URL =
  "https://chromewebstore.google.com/detail/attest-by-pluto/imopogegjchcjipnmbebamjlahnebocd";
export const IOS_APP_STORE_LINK =
  "https://apps.apple.com/us/app/pluto-attest/id6479618714";

export const NOTARY_URL = "f06e560.notary.pluto.dev"; // https://www.notion.so/plutodev/Staging-Notary-Instances-17e7a922ef2980348446fb8a7ff57446?pvs=4 updated 1/28/25
export const NOTARY_PORT = 443;

const TEMP_STATIC_ORIGO_MANIFEST = {
  manifestVersion: "1",
  id: "reddit-user-karma",
  title: "Total Reddit Karma",
  description: "Generate a proof that you have a certain amount of karma",
  prepareUrl: "https://www.reddit.com/login/",
  request: {
    method: "GET",
    version: "HTTP/1.1",
    url: "https://gist.githubusercontent.com/mattes/23e64faadb5fd4b5112f379903d2572e/raw/74e517a60c21a5c11d94fec8b572f68addfade39/example.json",
    headers: {
      "accept-encoding": "identity",
    },
    body: {
      userId: "<% userId %>",
    },
    vars: {
      userId: {
        regex: "[a-z]{,20}+",
      },
      token: {
        type: "base64",
        length: 32,
      },
    },
  },
  response: {
    status: "200",
    version: "HTTP/1.1",
    message: "OK",
    headers: {
      "Content-Type": "text/plain; charset=utf-8",
    },
    body: {
      json: ["hello"],
      contains: "this_string_exists_in_body",
    },
  },
};
